import { parse, format } from "date-fns";
import { Country, defaultCountry, getSimpleCountryCode } from "./countries";

const serverFormats = {
  dateTime: "yyyy-MM-dd HH:mm:ss",
};

const countryFormats = {
  dateTime: "dd/MM/yyyy HH:mm:ss",
  dateTimeWithoutSeconds: "dd/MM/yyyy HH:mm",
};

type ServerFormatValue = keyof typeof serverFormats;
type CountryFormat = typeof countryFormats;

const countriesFormats: Record<Country, CountryFormat> = {
  pt: countryFormats,
  es: {
    dateTime: "dd/MM/yyyy HH:mm:ss",
    dateTimeWithoutSeconds: "dd/MM/yyyy HH:mm",
  },
  en: {
    dateTime: "dd/MM/yy HH:mm:ss",
    dateTimeWithoutSeconds: "dd/MM/yy HH:mm",
  },
};

export const parseServerDate = (
  dateString: string,
  dateFormat: ServerFormatValue = "dateTime"
): Date => {
  return parse(dateString, serverFormats[dateFormat], new Date());
};

export const formatDate = (
  date: Date,
  {
    dateFormat = "dateTime",
    locale = defaultCountry,
  }: { dateFormat?: keyof CountryFormat; locale?: string } = {}
): string => {
  const country = getSimpleCountryCode(locale) as Country;

  return format(date, countriesFormats[country][dateFormat]);
};
